import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useLocation, useHistory } from "react-router-dom";
import { useRef, useState, useEffect, useMemo } from "react";
import {
  mrStatementGroupInfo,
  mrStatementDataObject,
  mrStatementValidate,
  mrStatementTableHeader,
  mrStatementTableItems,
} from "../config/adminBiltyReport.js";
import { result } from "lodash";
let ex_data = [];
let ex_data2 = [];

function AdminBiltyReport({ sessionObject }) {
    const history = useHistory();
    const lcChargeHeader =
      process.env.REACT_APP_CLIENT === "avr" ||
      process.env.REACT_APP_CLIENT === "sgtc" ||
      process.env.REACT_APP_CLIENT === "jtsa" ||
      process.env.REACT_APP_CLIENT === "std" ||
      process.env.REACT_APP_CLIENT === "nptc" ||
      process.env.REACT_APP_CLIENT === "arbuda" ||
      process.env.REACT_APP_CLIENT === "bgtc" 
        ? "Collection Charge"
        : "LC Charge";
  
    const guruColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Parent Party",
        accessor: "parent_company_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Goods Invoice Value",
        accessor: "goods_invoice_value",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Pkgs",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Charge Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Item",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Rate",
        accessor: "rate",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: lcChargeHeader,
        accessor: "lc_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Other Amt",
        accessor: "other_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "PF",
        accessor: "pf",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR Date.",
        accessor: "mr_date",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Transporter Freight",
        accessor: "transporter_freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Crossing Hire",
        accessor: "crossing_hire",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );

  const gtransColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Parent Party",
        accessor: "parent_company_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Pkgs",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Item",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Goods Invoice Value",
        accessor: "goods_invoice_value",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: lcChargeHeader,
        accessor: "lc_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Collection Amt",
        accessor: "collection_amount",
        canFilter: true,
        width: "100px",
        minWidth: "70px",
      },
      {
        Header: "Service Charge",
        accessor: "service_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );
  
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const bbacColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Parent Party",
        accessor: "parent_company_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      // {
      //   Header: "Packages",
      //   accessor: "no_of_package",
      //   canFilter: true,
      //   width: "50px",
      //   minWidth: "50px",
      // },
      {
        Header: "Pkgs",
        accessor: "no_of_package",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Item",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Rate",
        accessor: "rate",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Crossing Charge",
        accessor: "crossing_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Other Amt",
        accessor: "other_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Amount",
        accessor: "amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR Date.",
        accessor: "mr_date",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },
      {
        Header: "Crossing Outward No",
        accessor: "crossing_outward_no",
        canFilter: true,
      },
      {
        Header: "Crossing Outward Date",
        accessor: "crossing_outward_date",
        canFilter: true,
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Charge Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Goods Invoice Value",
        accessor: "goods_invoice_value",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Transporter Freight",
        accessor: "transporter_freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Crossing Hire",
        accessor: "crossing_hire",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );

  const avrColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Parent Party",
        accessor: "parent_company_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      // {
      //   Header: "Packages",
      //   accessor: "no_of_package",
      //   canFilter: true,
      //   width: "50px",
      //   minWidth: "50px",
      // },
      {
        Header: "Pkgs",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Item",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Paid Due Name",
        accessor: "paid_due_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Rate",
        accessor: "rate",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: lcChargeHeader,
        accessor: "lc_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Other Amt",
        accessor: "other_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Amount",
        accessor: "amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Collection Amt",
        accessor: "collection_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR Date.",
        accessor: "mr_date",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },
      {
        Header: "Crossing Outward No",
        accessor: "crossing_outward_no",
        canFilter: true,
      },
      {
        Header: "Crossing Outward Date",
        accessor: "crossing_outward_date",
        canFilter: true,
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Charge Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Goods Invoice Value",
        accessor: "goods_invoice_value",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Transporter Freight",
        accessor: "transporter_freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Crossing Hire",
        accessor: "crossing_hire",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );
  
  const bgtcColumns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        id: "sr_no",
        Cell: ({ row }) => row.index + 1,
        width: "60px",
        minWidth: "60px",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Ref No",
        accessor: "reference_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Billing Party Name",
        accessor: "billing_party_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "120px",
        minWidth: "120px",
        canFilter: true,
      },
      {
        Header: "Package",
        accessor: "no_of_package",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Weight",
        accessor: "weight",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "E-Way Count",
        accessor: "eway_count",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Item Name",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Freight",
        accessor: "freight",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Bilty Charge",
        accessor: "bilty_charge",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "DD Charge",
        accessor: "door_del_charge",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Collection Charge",
        accessor: "lc_charge",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "PF",
        accessor: "other_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan Inward",
        accessor: "is_inwarded",
        canFilter: true,
      },
      {
        Header: "Local Deli No",
        accessor: "local_delivery_no",
        canFilter: true,
      },
      {
        Header: "Local Deli Date",
        accessor: "local_delivery_date",
        canFilter: true,
        Cell: ({ value }) => {
          if (!value) return "";
          return value.split("T")[0];
        },
        width: "120px",
        minWidth: "120px",
      },
      {
        Header: "Tempo Collection",
        accessor: "tempo_collection",
        canFilter: true,
      },
      {
        Header: "MR No",
        accessor: "mr_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "MR Date",
        accessor: "mr_date",
        width: "80px",
        minWidth: "60px",
        canFilter: true,
      },
      {
        Header: "Amount",
        accessor: "amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );

  const bgtcAdminLRColumns = React.useMemo(
    () => [
      {
        Header: "Sr No",
        id: "sr_no",
        Cell: ({ row }) => row.index + 1,
        width: "60px",
        minWidth: "60px",
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "25px",
        minWidth: "25px",
        canFilter: true,
      },
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Ref No",
        accessor: "reference_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      // {
      //   Header: "Station From",
      //   accessor: "station_from_name",
      //   canFilter: true,
      // },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Billing Party Name",
        accessor: "billing_party_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Item Name",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "120px",
        minWidth: "120px",
        canFilter: true,
      },
      {
        Header: "Package",
        accessor: "no_of_package",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Weight",
        accessor: "weight",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "E-Way Count",
        accessor: "eway_count",
        width: "50px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      // {
      //   Header: "Freight",
      //   accessor: "freight",
      //   width: "70px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      // {
      //   Header: "Bilty Charge",
      //   accessor: "bilty_charge",
      //   width: "50px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      // {
      //   Header: "Hamali",
      //   accessor: "hamali",
      //   width: "70px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      // {
      //   Header: "DD Charge",
      //   accessor: "door_del_charge",
      //   width: "70px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      // {
      //   Header: "Collection Charge",
      //   accessor: "lc_charge",
      //   width: "70px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      // {
      //   Header: "PF",
      //   accessor: "other_amount",
      //   width: "70px",
      //   minWidth: "50px",
      //   canFilter: true,
      // },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "Challan Inward",
        accessor: "is_inwarded",
        canFilter: true,
      },
      {
        Header: "Local Deli No",
        accessor: "local_delivery_no",
        canFilter: true,
      },
      {
        Header: "Local Deli Date",
        accessor: "local_delivery_date",
        canFilter: true,
        Cell: ({ value }) => {
          if (!value) return "";
          return value.split("T")[0];
        },
        width: "120px",
        minWidth: "120px",
      },
      {
        Header: "Tempo Collection",
        accessor: "tempo_collection",
        canFilter: true,
      },
      {
        Header: "MR No",
        accessor: "mr_no",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "MR Date",
        accessor: "mr_date",
        width: "80px",
        minWidth: "60px",
        canFilter: true,
      },
      {
        Header: "MR Amount",
        accessor: "mr_total_amount",
        width: "70px",
        minWidth: "50px",
        canFilter: true,
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
    ],
    []
  );


  const defaultColumns = React.useMemo(
    () => [
      {
        Header: "Bilty No",
        accessor: "bilty_no",
        width: "90px",
        minWidth: "90px",
        canFilter: true,
      },
      {
        Header: "Suffix",
        accessor: "suffix",
        width: "60px",
        minWidth: "60px",
        canFilter: true,
      },
      {
        Header: "Bilty Date",
        accessor: "bilty_date",
        width: "80px",
        minWidth: "80px",
        // Cell: ({ value }) => {
        //   value = value.split("T");
        //   return value[0];
        // },
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to_name",
        canFilter: true,
      },
      {
        Header: "Destination",
        accessor: "destination_name",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Parent Party",
        accessor: "parent_company_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Private Marka",
        accessor: "private_marka_no_short",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },
      // {
      //   Header: "Packages",
      //   accessor: "no_of_package",
      //   canFilter: true,
      //   width: "50px",
      //   minWidth: "50px",
      // },
      {
        Header: "Pkgs",
        accessor: "pkgs",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Pay Type",
        accessor: "pay_type_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Item",
        accessor: "item_name",
        width: "100px",
        minWidth: "100px",
        canFilter: true,
      },

      {
        Header: "Rate",
        accessor: "rate",
        canFilter: true,
        width: "50px",
        minWidth: "50px",
      },
      {
        Header: "Freight",
        accessor: "freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "DD",
        accessor: "door_del_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: lcChargeHeader,
        accessor: "lc_charge",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Hamali",
        accessor: "hamali",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Other Amt",
        accessor: "other_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Amount",
        accessor: "amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Collection Amt",
        accessor: "collection_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Total Amt",
        accessor: "total_amount",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Challan",
        accessor: "booking_chalan_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR No.",
        accessor: "mr_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "MR Date.",
        accessor: "mr_date",
        canFilter: true,
        width: "80px",
        minWidth: "60px",
      },
      {
        Header: "Crossing Outward No",
        accessor: "crossing_outward_no",
        canFilter: true,
      },
      {
        Header: "Crossing Outward Date",
        accessor: "crossing_outward_date",
        canFilter: true,
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Trip No.",
        accessor: "trip_no",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "User",
        accessor: "created_by",
        canFilter: true,
      },
      {
        Header: "Charge Weight",
        accessor: "charge_weight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Goods Invoice Value",
        accessor: "goods_invoice_value",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Transporter Freight",
        accessor: "transporter_freight",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
      {
        Header: "Crossing Hire",
        accessor: "crossing_hire",
        canFilter: true,
        width: "70px",
        minWidth: "50px",
      },
    ],
    []
  );

  const getColumnsBasedOnClient = () => {
    const client = process.env.REACT_APP_CLIENT;

    if (client === "guru") {
      return guruColumns;
    } 
    if (client === "g_trans") {
      return gtransColumns;
    } 
    if (["avr", "sgtc", "arbuda", "std", "jtsa"].includes(client)) {
      return avrColumns;
    }
    if (client === "bgtc") {
      if (
        dateState.report_type !== "bilty" &&
        dateState.report_type !== "inward"
      ) {
        return bgtcAdminLRColumns;
      }

      return bgtcColumns;
    }
     if (client === "bbac") {
      return bbacColumns;
    }

    return defaultColumns;
  };

  // We'll start our table without any data
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);
  const download_ref = React.useRef(null);
  const download_ref1 = React.useRef(null);
  const download_ref2 = React.useRef(null);
  const sortIdRef = React.useRef(0);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    in_stock: "1",
    pending_bill:"2",
    all_branch: process.env.REACT_APP_CLIENT == "gdala_log" ? "N" : "Y",
    pending_mr: "",
    bilty_from: "",
    bilty_to: "",
  });
  const baseColumns = React.useMemo(() => getColumnsBasedOnClient(), [dateState.report_type]);
  const [orderedColumns, setOrderedColumns] = React.useState(baseColumns);

  React.useEffect(() => {
    setOrderedColumns(baseColumns);
  }, [baseColumns]);
  const [pageState, setPageState] = React.useState({
    total_amount: 0,
    total_weight: 0,
    total_pkgs: 0,
    total_bilties:0,
    total_pf:0,
    total_hamali:0,
    total_dd:0,
  });
  const [finalInput, setFinalInput] = React.useState({});
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();

  useEffect(() => {
    const reportType = query.get("report_type");
    // myForm.setPageStateByField("voucher_type", voucher);
    setDateState({
      ...dateState,
      ["report_type"]: reportType,
    });
  }, []);

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      console.log("12323", sortBy, customFilters, fetchId);

      try {
        for (let key in customFilters) {
          console.log("Key", customFilters[key].toLowerCase(), key);
          if (customFilters[key].toLowerCase() == "none") {
            customFilters[key] = null;
          }
        }

        setLoading(true);

        if (fetchId === fetchIdRef.current) {
          console.log("Date state", dateObject);

          let newObject = {};

          if (dateObject.report_type == "bilty") {
            newObject.created_from = String(
              sessionObject.sessionVariables.branch_id
            );
            if (dateObject.in_stock == "2") {
              newObject.owned_by = String(
                sessionObject.sessionVariables.branch_id
              );
            }
          }

          if (dateObject.pending_bill == "1") {
            newObject.pending_bill = String(1);
          }

          if (dateObject.all_branch == "N") {
            newObject.created_from = String(
              sessionObject.sessionVariables.branch_id
            );
          }

          if (dateObject.report_type == "inward") {
            newObject.owned_by = String(
              sessionObject.sessionVariables.branch_id
            );
            // if (dateObject.in_stock == "N") {
            //   newObject.created_from = String(
            //     sessionObject.sessionVariables.branch_id
            //   );
            // } else {
            //   newObject.owned_by = String(
            //     sessionObject.sessionVariables.branch_id
            //   );
            // }
          }

          // newObject.created_from = String(
          //   sessionObject.sessionVariables.branch_id
          // );

          if (
            process.env.REACT_APP_CLIENT === "bgtc" &&
            dateObject.pending_mr === "1"
          ) {
            newObject.pending_mr = "1";
          }

          newObject = { ...newObject, ...customFilters };

          if (process.env.REACT_APP_CLIENT === "bgtc") {
            if (dateObject.bilty_from)
              newObject.bilty_from = dateObject.bilty_from;

            if (dateObject.bilty_to)
              newObject.bilty_to = dateObject.bilty_to;
          }

          if (
            process.env.REACT_APP_CLIENT === "bgtc" &&
            (dateObject.bilty_from || dateObject.bilty_to)
          ) {
            const fyString = JSON.parse(
              sessionStorage.getItem("financial_year_for_fetch")
            )?.financial_year_for_fetch;

            if (fyString) {
              const startYY = fyString.split("-")[0];
              const fyStartYear = 2000 + Number(startYY);

              dateObject.date_from = new Date(
                `${fyStartYear}-04-01T00:00:00.000Z`
              );
            }
          }

          let inputData = {
            paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
            sort_fields: sortBy,
            filter_fields: newObject,
            date_dict: {
              date_from: dateObject.date_from,
              date_to: dateObject.date_to,
            },
          };

          setFinalInput(inputData);

          let response = await fetch(SERVER_URL + "/report/admin_lr", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(inputData),
          });

          let resp = await response.json();

          let setObj = {};

          if (fetchId === fetchIdRef.current) {
            if (resp["data"] && "total_rows" in resp) {
              setData(resp["data"]);
              setPageCount(Math.ceil(resp["total_rows"] / pageSize));
              setObj = {
                total_amount: resp["total_amount"],
                total_weight: resp["total_weight"],
                total_pkgs:
                  ["bgtc", "bbac"].includes(process.env.REACT_APP_CLIENT)
                    ? resp.total_no_of_pkgs
                    : resp.total_pkgs,
                total_bilties: resp["total_rows"],
                total_pf: resp["total_pf"],
                total_hamali: resp["total_hamali"],
                total_dd: resp["total_dd"],
              };
              setPageState({ ...pageState, ...setObj });
            }
            setLoading(false);
          }
        }
      } catch (error) {
        console.error("Error fetching admin LR report:", error);
        setLoading(false);
      }

      // We'll even set a delay to simulate a server here
      //   setTimeout(() => {
      //     // Only update the data if this is the latest fetch
      //     if (fetchId === fetchIdRef.current) {
      //       const startRow = pageSize * pageIndex;
      //       const endRow = startRow + pageSize;
      //     //   setData(serverData.slice(startRow, endRow));
      //       console.log("data", data);
      //       // Your server could send back total page count.
      //       // For now we'll just fake it, too
      //       setPageCount(Math.ceil(serverData.length / pageSize));

      //       setLoading(false);
      //     }
      //   }, 1000);
    },
    []
  );

  const fetchDataDebounced = useMemo(() => _.debounce(fetchData, 500), []);

  const getTitleName = () => {
    if (dateState.report_type == "bilty") {
      return "Bilty Report";
    } else if (dateState.report_type == "inward") {
      return "Inward Report";
    } else {
      return "Admin LR Report";
    }
  };

  const handleViewClick = (cell) => {
    const biltyNo =
      process.env.REACT_APP_CLIENT === "bgtc"
        ? cell[2]?.value
        : cell[0]?.value;

    const suffix =
      process.env.REACT_APP_CLIENT === "bgtc"
        ? cell[1]?.value
        : cell[1]?.value;

    history.push("/bilty", {
      biltyNo,
      suffix,
    });
  };

  return (
    <div className="report-bilty">
      <div className="form-header">{getTitleName()}</div>
      <div className="report-bilty-table-container">
        <div className="report-field-row ">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          <div>
            To Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_to}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_to"]: date,
                })
              }
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              // disabled={checkDisabledCondition({ name: "input_date" })}
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     myForm.makeFocusOnParticularFieldForItem(
              //       "eway_bill_no",
              //       0,
              //       "eway_bill_no"
              //     );
              //   }
              // }}
            />
          </div>
          {/* <div> */}
            <label>Pending Bill?</label>
            <select
              onChange={(e) => {
                const { name, value } = e.target;
                setDateState({
                  ...dateState,
                  [name]: value,
                });
              }}
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
              // disabled={checkDisabledCondition({ name: "is_crossing" })}
              value={dateState["pending_bill"]}
              name="pending_bill"
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     a.preventDefault();
              //     if (
              //       myForm.pageState.is_crossing == "N" ||
              //       myForm.pageState.is_crossing == "n"
              //     ) {
              //       myForm.makeFocusOnParticularField("bilty_no");
              //       return;
              //     } else {
              //       myForm.makeFocusOnParticularField("transporter_name");
              //       return;
              //     }
              //   }
              // }}
            >
              <option value="1" key="1">
                Yes
              </option>
              <option value="2" key="2">
                No
              </option>
            </select>
            {process.env.REACT_APP_CLIENT == "gdala_log" ?
            (sessionObject.sessionVariables.role_id == 1 ? 
            <>
              <label>All Branch?</label>
              <select
                  onChange={(e) => {
                  const { name, value } = e.target;
                  console.log("PULKIT_TEST_VALUE",name,value)
                  setDateState({
                      ...dateState,
                      [name]: value,
                  });
                  }}
                  // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                  // disabled={checkDisabledCondition({ name: "is_crossing" })}
                  value={dateState["all_branch"]}
                  name="all_branch"
              >
                  <option value="N" key="N">
                  N
                  </option>
                  <option value="Y" key="Y">
                  Y
                  </option>
              </select>
            </>
             : null) 
             :
            <>
              <label>All Branch?</label>
              <select
                  onChange={(e) => {
                  const { name, value } = e.target;
                  console.log("PULKIT_TEST_VALUE",name,value)
                  setDateState({
                      ...dateState,
                      [name]: value,
                  });
                  }}
                  // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
                  // disabled={checkDisabledCondition({ name: "is_crossing" })}
                  value={dateState["all_branch"]}
                  name="all_branch"
              >
                  <option value="N" key="N">
                  N
                  </option>
                  <option value="Y" key="Y">
                  Y
                  </option>
              </select>
            </>}

            <>
                  {
              process.env.REACT_APP_CLIENT === "bgtc" &&
              dateState["report_type"] !== "bilty" &&
              dateState["report_type"] !== "inward" && (
                <div>
                  <label>Pending MR?</label>
                  <select
                    name="pending_mr"
                    value={dateState.pending_mr}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setDateState({
                        ...dateState,
                        [name]: value,
                      });
                    }}
                  >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              )
            }
            </>
            
          </div>
          {/* <div>
            <label>Stock?</label>
            <select
              onChange={(e) => {
                const { name, value } = e.target;
                setDateState({
                  ...dateState,
                  [name]: value,
                });
              }}
              // ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
              // disabled={checkDisabledCondition({ name: "is_crossing" })}
              value={dateState["in_stock"]}
              name="in_stock"
              // onKeyPress={(a) => {
              //   if (a.key == "Enter") {
              //     a.preventDefault();
              //     if (
              //       myForm.pageState.is_crossing == "N" ||
              //       myForm.pageState.is_crossing == "n"
              //     ) {
              //       myForm.makeFocusOnParticularField("bilty_no");
              //       return;
              //     } else {
              //       myForm.makeFocusOnParticularField("transporter_name");
              //       return;
              //     }
              //   }
              // }}
            >
              <option value="1" key="1">
                All
              </option>
              <option value="2" key="2">
                In Stock
              </option>
            </select>
          </div> */}
        {/* </div> */}
        {process.env.REACT_APP_CLIENT === "bgtc" && (
          <div className="report-field-row" style={{ marginTop: "10px" }}>
            <div>
              <label style={{ marginRight: "5px" }}>From Bilty No:</label>
              <input
                type="text"
                name="bilty_from"
                value={dateState.bilty_from}
                onChange={(e) =>
                  setDateState({ ...dateState, bilty_from: e.target.value })
                }
              />
            </div>

            <div>
              <label style={{ marginRight: "5px" }}>To Bilty No:</label>
              <input
                type="text"
                name="bilty_to"
                value={dateState.bilty_to}
                onChange={(e) =>
                  setDateState({ ...dateState, bilty_to: e.target.value })
                }
              />
            </div>
          </div>
        )}
        
        <div className="chform-row">
          {mrStatementGroupInfo["group-1"].map(function (info) {
            return (
              <div className={info["className"]} key={info["name"]}>
                <label className={info["labelClassName"]}>
                  {info["label"]}:</label>
                  <input
                    size="8"
                    disabled={true}
                    type={info["type"]}
                    value={pageState[info["name"]]}
                    className={info["inputClassName"]} 
                  />
                {/* </label> */}
              </div>
            );
          })}
        </div>
        <ReportTable
          columns={orderedColumns}
          data={data}
          fetchData={fetchDataDebounced}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
          canView={true}
          handleViewClick={handleViewClick}
          enableColumnDragDrop={true}
          columnOrderStorageKey={`admin-lr-report-columns-${process.env.REACT_APP_CLIENT}-${dateState.report_type}`}
          onColumnReorder={setOrderedColumns}
        />
        <div className="form-footer">
          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="bilty_report_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Download as XLS"
              ref={(a) => (download_ref.current = a)}
            />
          </button>
          <button
            className="download-table-xls-button"
            onClick={async () => {
              setLoading(true);
              let dataToSend = {
                date_dict: finalInput.date_dict,
                filter_fields: finalInput.filter_fields,
              };
              let resp = await fetch(SERVER_URL + "/report/admin_lr", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(dataToSend),
              });
              let response = await resp.json();

              if (response["data"] && "total_rows" in response) {
                console.log(response["data"], "fsdfafsfds");
                // setData(response["data"]);
                ex_data = response["data"];
                // setPageCount(Math.ceil(response["total_rows"] / pageSize));
              }
              setLoading(false);
              download_ref.current.handleDownload();
            }}
          >
            Download as XLS
          </button>

          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="admin_print_report_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Download as XLS"
              ref={(a) => (download_ref1.current = a)}
            />
          </button>
          <button
            className="download-table-xls-button"
            onClick={async () => {
              setLoading(true);
              // let dataToSend = {
              //   date_dict: finalInput.date_dict,
              //   filter_fields: finalInput.filter_fields,
              // };
              console.log("final INput", finalInput);
              delete finalInput.paginate
              let resp = await fetch(SERVER_URL + "/report/admin_lr", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(finalInput),
              });
              let response = await resp.json();

              if (response["data"] && "total_rows" in response) {
                console.log(response["data"], "fsdfafsfds");
                // setData(response["data"]);
                ex_data = response["data"];
                // setPageCount(Math.ceil(response["total_rows"] / pageSize));
              }
              setLoading(false);
              download_ref1.current.handleDownload();
            }}
          >
            Consigor Wise excel
          </button>
          <button style={{ display: "none" }}>
            <ReactHTMLTableToExcel
              id="test-table-xls-button"
              className="download-table-xls-button"
              table="del_diff_excel"
              filename="tablexls"
              sheet="tablexls"
              buttonText="Del Diff XLS"
              ref={(a) => (download_ref2.current = a)}
            />
          </button>
          <button
            className="download-table-xls-button"
            onClick={async () => {
              setLoading(true);
              let dataToSend = {
                date_dict: finalInput.date_dict,
                filter_fields: finalInput.filter_fields,
              };
              let url = SERVER_URL + "/report/del_diff";

              // if(dateState.report_type == "inward" || dateState["report_type"] == "admin-inward") {
              //     url += "inward";
              // }

              let resp = await fetch(url, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(dataToSend),
              });
              let response = await resp.json();

              if (response["data"] && "total_rows" in response) {
                console.log(response["data"], "fsdfafsfds");
                // setData(response["data"]);
                ex_data2 = response["data"];
                // setPageCount(Math.ceil(response["total_rows"] / pageSize));
              }
              setLoading(false);
              download_ref2.current.handleDownload();
            }}
          >
            Delivery Diff Report
          </button>
          {ReportExcel.admin_bilty_report_excel_data(
            orderedColumns,
            { ex_data },
            fetchData,
            dateState,
            loading,
            pageCount,
            dateState
          )}

          {ReportExcel.admin_print_report_excel_data(
            { columns: orderedColumns },
            { ex_data },
            { fetchData },
            { dateState },
            { loading },
            { pageCount },
            { dateState }
          )}
          {ReportExcel.excel_del_diff(
            { ex_data2},
            { dateState }
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminBiltyReport;
